/**
 * @name usePedido
 * @author Keven Adan Bezerra | kevenadanb
 * @description Hook para usar o context de pedidos
 * @package src/contexts/PedidoContext/usePedido.tsx
 */

import { useContext } from "react";
import { IPedidoContext, PedidoContext } from "./PedidoContext";

/**
 * Hook para acessar o contexto de pedidos
 * @returns {IPedidoContext} Contexto de pedidos
 */
export const usePedido = (): IPedidoContext => {
  const context = useContext(PedidoContext);

  if (!context) {
    throw new Error("usePedido deve ser usado dentro de um PedidoProvider");
  }

  return context;
};
